/* <product-bundle>: tick products, live total, add all to cart in one request */
(() => {
  if (customElements.get('product-bundle')) return;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const fmt = cents => window.ttMoney(cents || 0);

  class ProductBundle extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-pb-add]');
      this.msg = this.querySelector('[data-pb-msg]');
      try { this.mainVariants = JSON.parse(this.querySelector('[data-pb-main-variants]')?.textContent || '{}'); } catch (e) { this.mainVariants = {}; }
      this.addEventListener('change', e => {
        const sel = e.target.closest('[data-pb-variant]');
        if (sel) this._applyOption(sel);
        this._update();
      });
      this.btn?.addEventListener('click', () => this._add());
      if (this.dataset.sync === 'true') this._syncMain();
      if (this.hasAttribute('data-lazy')) this._lazy(); else this._update();
    }

    /* Keep the "This item" row in step with the page's variant picker */
    _syncMain() {
      const input = document.getElementById('SelectedVariantId');
      if (!input) return;
      let last = input.value;
      const check = () => {
        if (input.value === last) return;
        last = input.value;
        const row = this.querySelector('.pb-row--main');
        const v = this.mainVariants[last];
        if (!row || !v) return;
        row.dataset.variantId = last;
        const chk = row.querySelector('[data-pb-check]');
        if (chk) chk.checked = v[3] !== false;
        this._paintRow(row, v[0], v[1], v[2]);
        this._update();
      };
      ['click', 'change'].forEach(ev => document.addEventListener(ev, () => setTimeout(check, 60), { passive: true }));
    }

    _applyOption(sel) {
      const row = sel.closest('[data-pb-row]');
      const o = sel.selectedOptions[0];
      row.dataset.variantId = o.value;
      this._paintRow(row, +o.dataset.price, +o.dataset.compare, o.dataset.img);
    }
    _paintRow(row, price, compare, img) {
      row.dataset.price = price; row.dataset.compare = compare;
      const p = row.querySelector('[data-pb-price]'), c = row.querySelector('[data-pb-compare]'), pct = row.querySelector('[data-pb-pct]');
      if (p) p.textContent = fmt(price);
      const sale = compare > price;
      if (c) { c.hidden = !sale; c.textContent = fmt(compare); }
      if (pct) { pct.hidden = !sale; pct.textContent = sale ? `-${Math.round((compare - price) * 100 / compare)}%` : ''; }
      const im = row.querySelector('[data-pb-img]');
      if (img && im) { im.src = img; im.removeAttribute('srcset'); }
    }

    _rows() { return [...this.querySelectorAll('[data-pb-row]')].filter(r => r.querySelector('[data-pb-check]')?.checked); }
    _update() {
      const rows = this._rows();
      const total = rows.reduce((a, r) => a + (+r.dataset.price || 0), 0);
      const compare = rows.reduce((a, r) => a + (+r.dataset.compare || 0), 0);
      const t = this.querySelector('[data-pb-total]'), tc = this.querySelector('[data-pb-total-compare]'), tp = this.querySelector('[data-pb-total-pct]');
      if (t) t.textContent = fmt(total);
      const sale = compare > total;
      if (tc) { tc.hidden = !sale; tc.textContent = fmt(compare); }
      if (tp) { tp.hidden = !sale; tp.textContent = sale ? `-${Math.round((compare - total) * 100 / compare)}%` : ''; }
      const extra = rows.filter(r => !r.classList.contains('pb-row--main')).length;
      if (this.btn) {
        const n = rows.length;
        this.btn.disabled = extra === 0;
        const base = this.dataset.label || 'Add bundle to cart';
        this.btn.textContent = n > 1 ? `${base} (${n} items)` : base;
      }
      this.querySelectorAll('[data-pb-row]').forEach(r => r.classList.toggle('is-off', !r.querySelector('[data-pb-check]')?.checked));
    }

    /* Shopify recommendations, fetched only when the bundle scrolls into view */
    _lazy() {
      const load = async () => {
        const list = this.querySelector('[data-pb-list]');
        try {
          // Same-tag products via search, otherwise Shopify recommendations
          const url = this.dataset.searchQ
            ? `${root}search?q=${encodeURIComponent(this.dataset.searchQ)}&type=product&options[unavailable_products]=hide&section_id=product-bundle-recs`
            : `${root}recommendations/products?product_id=${this.dataset.productId}&limit=${this.dataset.limit}&intent=${this.dataset.intent}&section_id=product-bundle-recs`;
          const html = await (await fetch(url)).text();
          const src = new DOMParser().parseFromString(html, 'text/html').querySelector('.pb-recs-src');
          const rows = src ? [...src.querySelectorAll('[data-pb-row]')].filter(r => r.dataset.productId !== this.dataset.productId).slice(0, parseInt(this.dataset.limit) || 4) : [];
          if (!rows.length) { this.hidden = true; return; }
          list.replaceChildren(...rows);
          if (this.dataset.preselect === 'true') list.querySelectorAll('[data-pb-check]').forEach(c => { c.checked = true; });
        } catch (e) { this.hidden = true; return; }
        this._update();
      };
      if (!('IntersectionObserver' in window)) { load(); return; }
      const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); load(); } }, { rootMargin: '300px' });
      io.observe(this);
    }

    async _add() {
      const items = this._rows().map(r => ({ id: +r.dataset.variantId, quantity: 1 }));
      if (!items.length) return;
      this.btn.disabled = true; this.btn.classList.add('btn--loading');
      if (this.msg) this.msg.textContent = '';
      try {
        if (window.cartDrawer?.addItems) {
          await window.cartDrawer.addItems(items);
          window.cartDrawer.afterAdd();
        } else {
          const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          if (!res.ok) throw new Error((await res.json()).description || 'Could not add to cart');
          window.location.href = `${root}cart`;
        }
      } catch (err) {
        if (this.msg) this.msg.textContent = err.message || 'Could not add to cart';
      }
      this.btn.classList.remove('btn--loading');
      this._update();
    }
  }
  customElements.define('product-bundle', ProductBundle);
})();
